import './AddFilter.sass';

import React from 'react';
import Button from 'react-bootstrap-button-loader';

import { FIXED_DUTY_STATE } from '../../../constants/examConstants';

class AddFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      Assignment: 'Assigned to bibs',
      Rank: '',
    };
  }

  componentWillMount() {
    if (this.props.filter) {
      this.setState({
        Assignment: this.props.filter.book_status,
        Rank: this.props.filter.rank,
      });
    }
  }

  renderFilters = (filters, name) => (
    <div className="filterContainer">
      <div className="filterName">{name}</div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div className="boxesContainer">
          {filters.map((filter) => (
            <div
              key={filter}
              className={
                filter === this.state[name === 'Pay grade' ? 'Rank' : name]
                  ? 'filterBox active'
                  : 'filterBox'
              }
              onClick={() => {
                if (name === 'Pay grade') {
                  this.setState({ Rank: filter });
                } else {
                  this.setState({ [name]: filter });
                }
              }}
            >
              {filter}
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  getFilterData = () => {
    if (!this.props.filter) {
      if (this.state.Assignment === 'Assigned to bibs')
        return {
          book_status: this.state.Assignment,
          dutystate: FIXED_DUTY_STATE, // Regular
          rank: this.state.Rank,
          rate: this.props.rate.id,
        };
      return {
        book_status: this.state.Assignment,
        rate: this.props.rate.id,
      };
    }
    const updatedFilter = this.props.filter;
    if (this.state.Assignment === 'Assigned to bibs') {
      updatedFilter.book_status = this.state.Assignment;
      updatedFilter.dutystate = FIXED_DUTY_STATE; // Regular
      updatedFilter.rank = this.state.Rank;
      updatedFilter.rate = this.props.rate.id;
    } else {
      updatedFilter.book_status = this.state.Assignment;
      updatedFilter.rate = this.props.rate.id;
    }
    return updatedFilter;
  };

  render() {
    return (
      <div className="add-filter-component">
        {this.renderFilters(
          ['Assigned to bibs', 'Not assigned to bibs'],
          'Assignment',
        )}
        {this.state.Assignment === 'Assigned to bibs' && (
          <div className="mTop20 rankColumn">
            {this.renderFilters(['E5', 'E6'], 'Pay grade')}
          </div>
        )}
        <div className="separatorLine" />
        <div className="bottomButtons">
          <Button
            onClick={() => {
              const filter = this.getFilterData();
              this.props.onSubmit(filter);
              this.props.onCancel();
            }}
            className="btn btn-success"
            type="submit"
          >
            {this.props.filter ? 'Update' : 'Add'}
          </Button>
          <Button
            className="btn btn-secondary"
            onClick={() => this.props.onCancel()}
          >
            Cancel
          </Button>
        </div>
      </div>
    );
  }
}

export default AddFilter;
